import { render, staticRenderFns } from "./CompanyMobile.vue?vue&type=template&id=0e642ea6&scoped=true"
import script from "./CompanyMobile.vue?vue&type=script&lang=js"
export * from "./CompanyMobile.vue?vue&type=script&lang=js"
import style0 from "./CompanyMobile.vue?vue&type=style&index=0&id=0e642ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e642ea6",
  null
  
)

export default component.exports